import TvPanel from './TvPanel';

export default TvPanel;
